import { Container, styled } from '@mui/material';

export const TabPanelContainerStyled = styled(Container)(({ theme }) => ({
  padding: '24px 24px 58px',

  borderRadius: '16px 16px 0 0',
  background: theme.palette.grey[50],
}));
